import { webscriptApi } from "@/AlfrescoApi.js";

/**
 * Service for managing condig file
 */
class ConfigService {
  /**
   * Récupère le fichier de configuration pour une application donnée.
   * @param {string} app - Le nom de l'application (ex: "espaces").
   * @param {string} filename - Le nom du fichier de configuration (ex:"env-config.json")
   * @returns {Promise<Object>} Une promesse qui se résout avec l'objet de configuration.
   */
  getConfig(app, filename) {
    const webscriptUrl = `fr/jeci/pristy/config/${app}/${filename}`;
    return webscriptApi.executeWebScript("GET", webscriptUrl);
  }

  /**
   * Met à jour le fichier de configuration sur le serveur.
   * @param {string} app - Le nom de l'application.
   * @param {string} filename - Le nom du fichier de configuration (ex:"env-config.json")
   * @param {Object} configObject - L'objet de configuration complet à sauvegarder.
   * @returns {Promise<Object>} Une promesse qui se résout avec la réponse du serveur.
   */
  updateConfig(app, filename, configObject) {
    const webscriptUrl = `fr/jeci/pristy/config/${app}/${filename}`;
    return webscriptApi.executeWebScript(
      "PUT",
      webscriptUrl,
      null,
      null,
      null,
      configObject,
    );
  }

  /**
   * Validates a value against a type.
   * Returns an error message (string) on failure, or null if it is valid.
   */
  validateValueByType(value, type) {
    if (type === "number") {
      if (isNaN(parseFloat(value)) || !isFinite(value)) {
        return this.$t("config.errors.invalidNumber");
      }
    }
    if (type === "boolean") {
      const lowerCaseValue = String(value).toLowerCase();
      if (lowerCaseValue !== "true" && lowerCaseValue !== "false") {
        return this.$t("config.errors.invalidBoolean");
      }
    }
    if (type === "array" || type === "object") {
      try {
        // Ensure the parsed type actually matches
        const parsed = JSON.parse(value);
        const parsedType = Array.isArray(parsed) ? "array" : typeof parsed;
        if (
          (type === "array" && parsedType !== "array") ||
          (type === "object" && parsedType !== "object")
        ) {
          return this.$t("config.errors.typeMismatch", { type });
        }
      } catch {
        return null;
      }
    }
    // The 'string' type is always valid.
    return null;
  }
}

export default new ConfigService();
